(function($){

	$(document).ready(function(){

		$(document).on('click','.accordion .accordion-item .accordion-trigger',function(e){
			e.preventDefault();
			$accordion_item = $(this).parents('.accordion-item');
			$accordion_siblings = $accordion_item.siblings('.accordion-item');
			$accordion_siblings.removeClass('open');
			$accordion_item.toggleClass('open');
			
			if($accordion_item.hasClass('open')) {
				$accordion_item.find('.location-name').addClass('h2');
			} else {
				$accordion_item.find('.location-name').removeClass('h2');
			}
		});

	});
	
})(jQuery);